import { Row } from "antd";
import TableFilter from "components/tableFilter/tableFilter";
import { useFetchCreditorGroupQuery } from "features/mergeGroups/debtorMergeGroupAPI";
import { useState, useMemo } from "react";
import moment from "moment-timezone";
import { debounce } from "common/utils";
import MergeDebtorsTable from "./mergeDebtorsTable";

const initialFilterState = {
  matchDate: null,
  mergeGroupId: null,
  debtorName: "",
};

function MergeDebtorsListTab() {
  const { data: mergeGroups } = useFetchCreditorGroupQuery();

  const [filterStates, setFilterStates] = useState(initialFilterState);

  function setFilterProperty(name, value) {
    setFilterStates((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
      return newState;
    });
  }

  // Create a debounced version of setFilterProperty for text inputs
  const debouncedSetFilterProperty = debounce((name, value) => {
    setFilterProperty(name, value);
  }, 500);

  // This is the structure of the filters that will be displayed on the page
  const filteredStructure = [
    {
      title: "Match Date",
      name: "matchDate",
      type: "date",
      onChange: (event) => setFilterProperty("matchDate", event),
    },
    {
      title: "Merge Group",
      name: "mergeGroupId",
      type: "dropdown",
      dropdown: {
        onChange: (event) => {
          setFilterProperty("mergeGroupId", event);
        },
        options: mergeGroups?.map((group) => ({
          label: group.groupName,
          value: group.id,
        })),
        placeholder: "Select Merge Group(s)...",
      },
    },
    {
      title: "Debtor Name",
      name: "debtorName",
      type: "text",
      placeholder: "Enter Debtor Name...",
      onChange: (event) => debouncedSetFilterProperty("debtorName", event.target.value),
    },
  ];

  // Memoize query parameters to ensure RTK Query detects changes
  const queryParams = useMemo(() => {
    const params = {};

    // Convert mergeGroupIds to mergeGroupId (singular) - API expects single group
    if (filterStates.mergeGroupId) {
      params.mergeGroupId = filterStates.mergeGroupId;
    }

    // Convert matchDate to date range parameters
    if (filterStates.matchDate && filterStates.matchDate.length === 2) {
      const [startDate, endDate] = filterStates.matchDate;
      if (startDate) {
        params.createdAtStart = moment(startDate).format("YYYY-MM-DD");
      }
      if (endDate) {
        params.createdAtEnd = moment(endDate).format("YYYY-MM-DD");
      }
    }

    if (filterStates.debtorName) {
      params.debtorName = filterStates.debtorName;
    }

    return params;
  }, [filterStates.mergeGroupId, filterStates.matchDate, filterStates.debtorName]);

  function resetFilters() {
    setFilterStates(initialFilterState);
  }

  return (
    <Row wrap={false}>
      <TableFilter filteredStructure={filteredStructure} onReset={() => resetFilters()} />
      <MergeDebtorsTable queryParams={queryParams} mergeGroups={mergeGroups} />
    </Row>
  );
}

export default MergeDebtorsListTab;
